import { AxiosError } from "axios";

export type PageMeta = {
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  totalRecords: number;
};

export interface GeneralResponse<T> {
  code: number;
  data: T;
  errors: any;
  message: string;
  pageMeta: PageMeta;
  succeeded: boolean;
}

export type DataErrorResponse<T> = {
  data?: GeneralResponse<T>;
  error?: AxiosError<any>;
};

export type PrequalifyResponseData = {
  applicantAge: number;
  createdAt: string;
  debtToIncomeRatio: number;
  documents: File[];
  documentsUploadedAt: string;
  downPayment: number;
  dtiBenchmark: number;
  effectiveLoanAmount: number;
  eligibilityMessage: string;
  employmentType: number;
  externalMortgageProperty: null;
  forwardedToBankAt: string;
  id: number;
  incomeCurrency: string;
  incomeProfile: null;
  interestRate: number;
  isEligible: boolean;
  loanAmount: number;
  location: number;
  monthlyIncomeNGN: number;
  monthlyRepayment: number;
  mortgageApplicationStatus: number;
  mortgageFunderId: string;
  pensionAdmin: string;
  preQualifiedAt: string;
  propertyId: number;
  repaymentFrequency: number;
  repaymentSchedule: [[Object]];
  rsaNumber: string;
  salaryStructure: string;
  source: number;
  submittedAt: string;
  tenorInMonths: number;
  titleSearchPaymentMade: boolean;
  titleSearchPaymentReference: string;
  titleSearchReceiptUrl: string;
  totalInterestPaid: number;
  totalRepaymentAmount: number;
  totalUpfrontCost: number;
  upfrontFees: number;
  useRSA: boolean;
  userId: string;
};

export type AttachPropertyResponseData = unknown;
export type MortDocumentUploadResponseData = unknown;
export type SubmitMortgageResponseData = unknown;

export type PrequalifyResponse = DataErrorResponse<PrequalifyResponseData>;
export type AttachPropertyResponse =
  DataErrorResponse<AttachPropertyResponseData>;
export type MortDocumentUploadResponse =
  DataErrorResponse<MortDocumentUploadResponseData>;
export type SubmitMortgageResponse =
  DataErrorResponse<SubmitMortgageResponseData>;

export type PrequalifyRequest = {
  source: number;
  location: number;
  applicantType: number;
  loanAmount: number;
  downPayment: number;
  upfrontFees: number;
  interestRate: number;
  tenorInMonths: number;
  currency: string;
  repaymentFrequency: number;
  monthlyIncome: number;
  coBorrowerMonthlyIncome: number;
  coBorrowerCurrency: string;
  applicantAge: number;
  useRSA: boolean;
  rsaNumber: string;
  pensionAdmin: string;
  propertyId: number;
  hasCoBorrower?: boolean;
  hasRSA?: boolean;
};

export type AttachPropertyRequest = {
  mortgageApplicationId: number;
  externalProperty: {
    propertyName: string;
    address: string;
    propertyType: string;
    propertyValue: number;
    sellerName: string;
    sellerPhone: string;
    sellerEmail: string;
  };
};

export type DocumentFormat = {
  uri: string;
  name: string;
  filename: string;
  type: string;
};

export type UploadDocExtMortageReq = {
  MortgageApplicationId: number;
  DocumentType: number;
  File: File;
};

export type UploadDocMortSalaryBusinessReq = {
  hasAccessAccount: boolean;
  accountNumber: string;
  statementOfAccount: File;
  meansOfIdentification: File;
  letterOfEmployment?: File;
  paySlip?: File;
  evidenceOfPayment?: File;
  businessRegistration?: File;
};

export const DocumentTypes = [
  { document: "Payslip", value: 0, finder: "paySlip" },
  { document: "EmploymentLetter", value: 1, finder: "letterOfEmployment" },
  { document: "BankStatement", value: 2, finder: "statementOfAccount" },
  { document: "BusinessBankStatement", value: 3, finder: "" },
  { document: "MeansOfId", value: 4, finder: "meansOfIdentification" },
  {
    document: "BusinessRegistration",
    value: 5,
    finder: "businessRegistration",
  },
  { document: "ProofOfResidence", value: 6, finder: "" },
  { document: "DiasporaIncomeVerification", value: 7, finder: "" },
  {
    document: "SellerOfferAcceptanceLetter",
    value: 8,
    finder: "aceptanceLetter",
  },
  { document: "TitleDocument", value: 9, finder: "titledDocument" },
  { document: "PropertyPhoto", value: 10, finder: "propertyPhoto" },
  { document: "W2", value: 11, finder: "" },
  { document: "NationalInsurance", value: 12, finder: "" },
  { document: "TaxEvidence", value: 13, finder: "" },
  { document: "TitleSearchReceipt", value: 14, finder: "" },
  { document: "AdditionalPayment", value: 15, finder: "evidenceOfPayment" },
  { document: "Other", value: 16, finder: "" },
];
